// src/i18n/es.ts
import type { Translations } from "./index";

export const es: Translations = {
  nav: {
    services: "Servicios",
    reviews: "Opiniones",
    contact: "Contacto",
  },
  hero: {
    title: "Mudanzas rápidas y seguras en Barcelona",
    subtitle:
      "Servicio de mudanzas 24h en Barcelona y toda Cataluña, con equipo profesional, embalaje seguro y trato cuidadoso en cada traslado. Te damos un presupuesto inmediato por WhatsApp, sin complicaciones.",
    callNow: "Llamar ahora",
    whatsapp: "WhatsApp",
  },
  quickQuote: {
    title: "Presupuesto rápido",
    name: "Tu nombre",
    from: "Dirección de recogida",
    to: "Dirección de entrega",
    date: "Fecha",
    sendWhatsApp: "Enviar por WhatsApp",
    helper: "Rellena los campos y te abrimos WhatsApp con el mensaje preparado.",
  },
  services: {
    title: "Servicios",
  },
  reviews: {
    title: "Opiniones de clientes",
    subtitle: "Valoración media 4.9 ★ en Google",
  },
  pricing: {
    title: "Precios orientativos",
    note: "*Precios sin IVA. Parking y peajes no incluidos.",
  },
  contact: {
    title: "Contacto",
    subtitle: "Pide presupuesto por teléfono, WhatsApp o email. Respuesta en minutos.",
    phone: "Tel:",
    whatsapp: "WhatsApp:",
    email: "Email:",
    sendMediaTitle: "Envíanos fotos o vídeo",
    sendMediaText:
      "Cuanta más info, mejor presupuesto. También podemos hacer una visita por videollamada.",
    openWhatsApp: "Abrir WhatsApp",
  },
};